var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container-fluid"},[_c('b-row',{staticClass:"mt-3"},[_c('b-col',[_c('h4',{staticClass:"ml-3"},[_vm._v("History")])])],1),_c('div',{staticClass:"pt-4"},[_c('TableBase',{attrs:{"items":_vm.fx,"fields":_vm.fields,"options":_vm.options,"busy":_vm.isLoading}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }